export default "__VITE_ASSET__49bca407__"